
  <mat-card style="width: 100%; min-height: 50vh" class="subscription-confirmation">
    <div class="row">
      <div class="col-md-8 offset-md-2">
        <h1 class="text-center mb-3">Thank you for subscribing!</h1>
        <h2 class="text-center mb-3">Some text</h2>
        <p class="text-center">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum feugiat est sit amet lorem dapibus auctor. Etiam ac elit sed elit malesuada ullamcorper. Suspendisse dolor urna, faucibus nec lacinia at, lacinia vel nulla. In auctor sagittis lectus, eu vulputate tellus. Sed tristique velit sit amet tempus finibus. Proin lorem magna, egestas id sem fermentum, aliquet pulvinar nulla. Etiam lectus nulla, viverra sed vehicula eu, pellentesque non sem. Praesent non massa at mauris imperdiet tempor quis porta nisl. Aliquam ultricies lacinia dictum. Donec ut orci lobortis, varius urna ut, lacinia turpis.
        </p>
      </div>
    </div>
   
  </mat-card>
